import {Alert,Box,Button,Card,CardContent,Typography} from '@mui/material';
import React,{useEffect,useMemo,useRef,useState} from 'react';
import {playAudio} from '../../../../utils/audioUtils';
import {stopCurrentAudio} from '../../utils/audioUtils';
import {readPronunciationReferences} from '../../utils/pronunciationReferences';
import {LessonStep} from '../../types';

interface Props {step:LessonStep;token:string|null;onNext:(score?:number)=>void;onBackToLetters?:()=>void;lessonId?:string;isLastStep?:boolean;}

const RecognitionStep:React.FC<Props>=({step,token,onNext,onBackToLetters,isLastStep=false})=>{
 const source=useMemo(()=>readPronunciationReferences(step.content.pronunciation_references),[step.content.pronunciation_references]);
 const target=typeof step.content.target_letter==='string'?step.content.target_letter:'';
 const values=step.content.options;
 const validOptions=Array.isArray(values)&&values.length>=2&&values.length<=12&&
   values.every(value=>typeof value==='string'&&value.trim().length>0)&&new Set(values).size===values.length&&values.includes(target);
 const reference=source?.items.find(item=>item.type==='letter'&&item.text===target);
 const available=!!target.trim()&&!!reference&&validOptions;
 const [selected,setSelected]=useState<string|null>(null),[played,setPlayed]=useState(false),[playing,setPlaying]=useState(false),[error,setError]=useState('');
 const version=useRef(0),continued=useRef(false);
 useEffect(()=>{
  const revision=version;revision.current++;continued.current=false;setSelected(null);setPlayed(false);setPlaying(false);setError('');
  return()=>{revision.current++;stopCurrentAudio();};
 },[step.id,token,target,reference?.audio_url,values]);
 const listen=async()=>{
  if(!reference||!token)return;const revision=version.current;setPlaying(true);setPlayed(false);setSelected(null);setError('');
  try{await playAudio(reference.audio_url,token);if(revision===version.current)setPlayed(true);}
  catch{if(revision===version.current)setError('Аудио этой буквы недоступно. Повторите загрузку.');}
  finally{if(revision===version.current)setPlaying(false);}
 };
 if(!available||!source||!reference||!token)return <Card><CardContent><Typography variant="h5">{step.title}</Typography>
  <Alert severity="error">{!token?'Для доступа к записи нужна действующая сессия.':'Материал для распознавания недоступен или имеет неподдерживаемый формат.'}</Alert>
  {onBackToLetters&&<Button onClick={onBackToLetters}>К выбору буквы</Button>}
 </CardContent></Card>;
 const correct=selected===target;
 return <Card><CardContent>
  <Typography variant="h5">{step.title}</Typography>
  {typeof step.content.instruction==='string'&&step.content.instruction&&<Typography sx={{my:1}}>{step.content.instruction}</Typography>}
  <Typography variant="caption">Источник: {source.source}; лицензия: {source.license}.</Typography>
  <Box sx={{my:2}}><Button variant="contained" disabled={playing} onClick={()=>void listen()}>Прослушать букву</Button></Box>
  {error&&<Alert severity="error">{error}</Alert>}
  <Box sx={{display:'flex',flexWrap:'wrap',gap:1,my:2}}>
   {(values as string[]).map(option=><Button key={option} disabled={!played||playing||correct}
     variant={selected===option?'contained':'outlined'} onClick={()=>setSelected(option)}>{option}</Button>)}
  </Box>
  {selected!==null&&<Alert severity={correct?'success':'warning'}>{correct?'Ответ совпадает с ответом источника.':'Ответ не совпадает с ответом источника. Попробуйте ещё раз.'}</Alert>}
  {isLastStep&&<Alert severity="info">Это последний шаг: завершение сохранит вашу отметку о прохождении без оценки навыка.</Alert>}
  <Button variant="contained" sx={{mt:2}} disabled={!correct||playing} onClick={()=>{if(!continued.current){continued.current=true;onNext();}}}>Продолжить без оценки</Button>
 </CardContent></Card>;
};
export default RecognitionStep;
